export default __webpack_public_path__ + "static/DSC_3315-3e14cdf4d1554e44507dee8084f09b02.png";